import { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';
import { PlusIcon, ExportIcon } from 'assets/icons';
import { CalendarDaysIcon } from '@heroicons/react/24/solid';
import Flyout, { useFlyout } from 'components/Flyout/Flyout';
import New from './New';
import { GetCraftsReservationExportDocument } from 'graphql/generated';
import { useSession } from 'contexts';
import Toast, { useToast } from 'components/Toast/Toast';
import List from './Components/List';
import Button from 'components/Button/Button';
import Tabs from 'components/Tabs/Tabs';
import { OrgSubtypes } from 'utils/orgTypes';
import Card from 'components/Card/Card';
import ScreenShot from 'assets/images/reservation.jpg';
import { useNavigate } from 'react-router-dom';
import isMobileApp from 'utils/isMobileApp';
import Calendar from './Components/Calendar/Calendar';
import { RefetchProvider } from 'contexts/RefetchContext';
import Header from 'components/Header/Header';
import ThumbButton from 'components/ThumbButton/ThumbButton';
import CogMenu from 'components/CogMenu/CogMenu';
        
let viewTabs = ["Calendar", "List"];
const Reservations = () => {
  const [size, setSize] = useState([0, 0]);
  const { flyoutProps, updateFlyout, closeFlyout } = useFlyout();
  const navigate = useNavigate();
  const [viewTab, setViewTab] = useState("Calendar");
  const { toastProps, showToast } = useToast();
  const { organizationId, organizationSubtype, user } = useSession();
  const { data, loading, error } = useQuery(GetCraftsReservationExportDocument, {
    variables: { organizationId},
  });
  const menuItems = [
    { 
      webAction: data?.reservationsCalendarLink,
      name: 'Export',
      webOnly: false
    }
  ]
  useLayoutEffect(() => {
    function updateSize() {
      if(window.innerWidth<520){
        setViewTab("List");
      }
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error :(</p>;
  
  return (
    <RefetchProvider>
      {/* TOAST */}
      <Toast {...toastProps} />
      <Flyout {...flyoutProps} />
      <div>
        <Header title="Reservations" icon={CalendarDaysIcon}>
          { organizationSubtype === OrgSubtypes.MULTI &&
            <>
              <div className="flex gap-2">
                <Button text="Add Reservation" color="navy" size="xs" className="grow hidden md:flex" icon={ <PlusIcon className="h-3 w-3 mr-2" /> } onClick={ () => updateFlyout({ title: 'New Reservation', content: <New closeFlyout={()=>{closeFlyout();}} /> }) } />
                <CogMenu items={menuItems} />
              </div> 
              <ThumbButton size="primary" role="add" onClick={ () => updateFlyout({ title: 'New Reservation', content: <New closeFlyout={()=>{closeFlyout();}} /> }) } />
              {/* <a className="md:hidden grow" href={data?.reservationsCalendarLink}>
                <ThumbButton size="secondary" role="export"/>
              </a> */}
            </>
          }
        </Header>
        {/* Reservation List/Calendar */}
        <>
        { organizationSubtype !== OrgSubtypes.MULTI ? <div>
            {isMobileApp() ?  
              <Card>
                <h1 className="text-center text-2xl font-bold text-brand-dark">This Feature is not available for your organization</h1>
              </Card>
            :
            <Card>
              <h1 className="text-center text-3xl font-bold text-brand-dark">Try Our Multi-Pilot Plan</h1>
              <h2 className="text-center text-xl font-semibold text-slate-400">Flight scheduling is available on our multi pilot plan.</h2>
              <div className='flex flex-col justify-center my-8 gap-7'>
                <img className="max-h-[26rem] mx-auto" src={ScreenShot} alt="" />
                <Button text="UPGRADE NOW" color="navy" size="sm" onClick={ () => navigate('/account/settings?settingsTab=Billing') } />
              </div>
            </Card>}
          </div> : 
          <div className="rounded border border-slate-300">
            { organizationSubtype === OrgSubtypes.MULTI && size[0] > 520 &&
              <div className="px-4 pt-1 bg-slate-50 border-b border-slate-200 gap-3 rounded-t">
                <Tabs items={viewTabs} activeItem={viewTab} setActiveItem={setViewTab} />
              </div> 
            }
            { viewTab === "Calendar" ? <Calendar updateFlyout={updateFlyout} closeFlyout={closeFlyout}  /> 
            : 
            <List closeFlyout={closeFlyout} updateFlyout={updateFlyout} /> }
          </div>
        }
        </>
        
      </div>
    </RefetchProvider>
  );
};

export default Reservations;
